export default __webpack_public_path__ + "static/media/Soulcalibur.2cc6bb39.jpg";